import { render, staticRenderFns } from "./DisputeResolutionMessages.vue?vue&type=template&id=261ee59d&scoped=true&"
import script from "./DisputeResolutionMessages.vue?vue&type=script&lang=js&"
export * from "./DisputeResolutionMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ee59d",
  null
  
)

export default component.exports